import { Link } from "react-router-dom";
import type { NewsArticle } from "@/mocks/news";
import { formatDate, formatViews, getCategoryById } from "@/utils/news";

interface Props {
  article: NewsArticle;
  showSummary?: boolean;
}

export default function ArticleListItem({ article, showSummary = true }: Props) {
  const category = getCategoryById(article.categoryId);

  return (
    <article className="group flex gap-3 md:gap-5 py-4 md:py-5 border-b border-background-200 last:border-0">
      <Link
        to={`/detail/${article.id}`}
        className="relative shrink-0 w-[112px] h-[84px] sm:w-[168px] sm:h-[112px] md:w-[208px] md:h-[140px] rounded-lg overflow-hidden bg-background-200 cursor-pointer"
        aria-label={article.title}
      >
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 黑料吃瓜网`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 px-1.5 py-0.5 rounded bg-primary-900/85 text-background-50 text-[10px] tracking-wide">
          {category?.shortName ?? "资讯"}
        </span>
      </Link>

      <div className="flex-1 min-w-0 flex flex-col">
        <Link to={`/detail/${article.id}`} className="cursor-pointer">
          <h3 className="font-heading text-[15px] sm:text-base md:text-lg font-semibold leading-snug text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
        </Link>
        {showSummary && (
          <p className="hidden sm:block mt-2 text-[13px] md:text-sm leading-relaxed text-foreground-600 line-clamp-2">
            {article.summary}
          </p>
        )}
        <div className="mt-auto pt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] md:text-xs text-foreground-500">
          <span className="text-foreground-700">{article.author}</span>
          <span className="text-background-400">·</span>
          <span>{formatDate(article.publishedAt)}</span>
          <span className="hidden sm:inline text-background-400">·</span>
          <span className="hidden sm:flex items-center gap-1">
            <i className="ri-eye-line" />
            {formatViews(article.views)}
          </span>
          <span className="ml-auto flex items-center gap-1.5">
            {article.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700">
                {tag}
              </span>
            ))}
          </span>
        </div>
      </div>
    </article>
  );
}